var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-header"}},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"center-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"time"},[_c('div',{staticClass:"refresh"},[_vm._v("刷新数据:")]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.currentTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }